export const FileType = {
	IMAGE: 'IMAGE',
	XLSX: 'XLSX',
	PDF: 'PDF',
	ZIP: 'ZIP',
};

export const ValidFileTypes = {
	[FileType.IMAGE]: [
		'image/jpeg',
		'image/jpg',
		'image/png',
		'image/gif',
		'image/x-icon',
	],
	[FileType.XLSX]: [
		'.csv',
		'.tsv',
		'.xls',
		'.xlsx',
		'text/csv',
		'text/tsv',
		'application/csv',
		'text/comma-separated-values',
		'application/tsv',
		'text/tab-separated-values',
		'application/excel',
		'text/anytext',
		'application/vnd.ms-excel', // Excel 2003 and earlier
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel 2007 and later
		'application/vnd.ms-excel.sheet.macroEnabled.12', // Macro-enabled Excel files
		'application/vnd.apple.numbers', // Apple Numbers
		'application/x-iwork-numbers-sffnumbers' // Apple Numbers
	],
	[FileType.PDF]: [
		'application/pdf'
	],
};
